<div class="text-medium-medium text-dark flex" i18n="@@label-code">
    Code
    <span class="text-red">*</span>
</div>
<button
    (click)="toggleDropdown(true)"
    aria-label="Country code"
    class="flex items-center gap-x-2.5 h-12 w-full border rounded-14px outline-none bg-white text-dark-6 text-medium-regular focus:outline-none focus-within:outline-none p-2.5 border-stroke hover:border-primary-color hover:border-solid focus:border-blue-light-3 focus:border-solid focus:border-3px focus:text-primary-text-color z-10"
>
    <span>{{ flag() }}</span>
    <span>{{ control.value }}</span>
    <companyid-chevron position="bottom" color="gray" class="ml-auto" smallSize />
</button>

@if (showDropdown()) {
    <div
        companyidClickOutside
        (onClickOutside)="toggleDropdown(false)"
        class="absolute top-[90px] text-medium-regular flex flex-col gap-5 p-15px text-dark-4 rounded-6px box-shadow-2 bg-white w-[335px] mob:w-fit max-h-[275px]"
    >
        <div class="flex flex-col bg-white sticky top-0">
            <input
                type="text"
                [formControl]="countryControl"
                placeholder="Search a country"
                class="outline-none"
                i18n-placeholder="@@placeholder-search-a-country"
            />
        </div>
        <hr />
        @if (filteredCountries().length > 0) {
            <div class="flex bg-white overflow-x-auto">
                <ul class="flex flex-col gap-y-2.5 text-dark-4 w-full">
                    @for (item of filteredCountries(); track item) {
                        <li
                            (click)="selectCountry(item)"
                            (keydown)="onKeydown($event, item)"
                            tabindex="0"
                            class="hover:bg-gray-2 w-full px-15px py-5px cursor-pointer gap-2.5 flex justify-between items-center"
                        >
                            <span>{{ item.dial_code }}</span>
                            <span>{{ item.translateKey | countriesTranslate }} </span>
                            <span>{{ item.flag }}</span>
                        </li>
                    }
                </ul>
            </div>
        } @else {
            <span class="text-center">Not found</span>
        }
    </div>
}
